var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v(" Copyright "),_c('a-icon',{attrs:{"type":"copyright"}}),_vm._v(" 2024 "),_c('span',[_vm._v("智慧水务管理平台")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }